module.exports = __webpack_public_path__ + "img/san.a7ce8051.jpg";